<div class="modal-header">
    <h4>
        {{title}}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>



<div class="modal-body">
    <ul class="list-group list-group-flush">
        <li class="list-group-item comment"
            *ngFor="let comment of comments">
            <div class="comment-header">
                <div class="comment-time">
                    {{comment.timestamp | date:'dd/MM/yyyy HH:mm:ss'}}
                    <small *ngIf="comment.lastChanged > comment.timestamp">
                        (edited {{ comment.lastChanged | date:'dd/MM/yyyy HH:mm:ss' }})
                    </small>
                </div>
                <div class="comment-text">
                    <ng-container *ngIf="editingCommentId !== comment.id; else editTemplate">
                        {{ comment.comment }}
                        <button class="btn btn-primary btn-sm"
                                (click)="startEdit(comment)"
                                style="margin-left:10px">
                            Edit
                        </button>
                    </ng-container>
                    <ng-template #editTemplate>
                        <textarea class="form-control"
                                  rows="3"
                                  [(ngModel)]="editedText">
                        </textarea>
                        <div class="mt-2 text-end">
                            <button class="btn btn-sm btn-secondary me-2"
                                    (click)="cancelEdit()">
                                Cancel
                            </button>
                            <button class="btn btn-sm btn-primary"
                                    (click)="saveEdit(comment)">
                                Save
                            </button>
                        </div>
                    </ng-template>
                </div>
            </div>
            <div class="attachments">
                <div class="attachment"
                        *ngFor="let attachment of comment.attachments"
                        (click)="show(attachment)">

                    <app-attachment [attachment]="attachment"></app-attachment>
                </div>
            </div>
        </li>
    </ul>
</div>
